<template>
  <div class="hello" :class="templateClass">
    <div :id="cindex" v-html="tem_data.tpl_html" v-show="isshow"></div>
  </div>
</template>

<script>
export default {
  name: "listtemplate",
  props: ["tem_data", "cindex"],
  data() {
    return {
      params: {},
      list_data: [],
      type: "",
      isshow: false,
      recommendCwiper: null
    };
  },
  computed: {
    templateClass() {
      return this.tem_data && this.tem_data.template_id
        ? "template-id-" + this.tem_data.template_id
        : "";
    }
  },
  created() {
    var _this = this;
    // document.getElementById('g_style').innerHTML += res.data[i].tpl_css;
    // $('#g_style').append(res.data[i].tpl_css)
    if (this.tem_data.resource.indexOf("/id/") != -1) {
      let urlarr = this.tem_data.resource.split("/");
      // this.$set(this.temdata,'api',);
      this.type = urlarr[urlarr.length - 1];
      _this.params = {
        api: "/" + urlarr[1] + "/" + urlarr[2] + "/" + urlarr[3],
        id: urlarr[urlarr.length - 1],
        center_id: this.tem_data.center_id,
        type: 2,
        len: this.tem_data.len
      };
    } else {
      this.type = 0;
      _this.params = {
        api: this.tem_data.resource,
        center_id: this.tem_data.center_id,
        type: 2,
        len: this.tem_data.len
      };
    }
    _this.getdata();
    // $.ajax({
    //   url:'/api/proxy/index',
    //   type:'get',
    //   data:{
    //     // user_type:usertype,
    //     api:'/v1/home_page/getcategory'
    //   },
    //   dataType:'json',
    //   success: function(res){
    //     if(res.status == 1){
    //       _this.tem_data = res.data[1];
    //       for(var i in res.data){
    //         document.getElementById('g_style').innerHTML += res.data[i].tpl_css;
    //         // $('#g_style').append(res.data[i].tpl_css)
    //       }
    //       if(res.data[1].resource.indexOf('/id/') != -1){
    //         let urlarr = res.data[1].resource.split('/');
    //         // this.$set(this.temdata,'api',);
    //         _this.params = {
    //           api: '/'+urlarr[1]+'/'+urlarr[2]+'/'+urlarr[3],
    //           id: urlarr[urlarr.length-1],
    //           center_id: res.data[1].center_id,
    //           type:1,
    //           len: res.data[1].len
    //         }
    //       }else{
    //         _this.params = {
    //           api: res.data[1].resource,
    //           center_id: res.data[1].center_id,
    //           type:1,
    //           len: res.data[1].len
    //         }
    //       }
    //       _this.getdata();
    //     }
    //   }
    // });
  },
  methods: {
    getdata() {
      var _this = this;
      this.$api.get("", this.params, res => {
        if (res.status == 1) {
          _this.listdata = res.data.list;
          _this.$nextTick(function() {
            var source = document.getElementById(_this.cindex).innerHTML;
            Handlebars.registerHelper("is_score", function(value) {
              if (value == undefined) {
                return "";
              } else {
                return "暂无评";
              }
            });
            // 注册一个 times helper
            Handlebars.registerHelper("grouped_each", function(
              items,
              groupSize,
              options
            ) {
              let out = "";
              let group = [];

              for (let i = 0; i < items.length; i++) {
                group.push(items[i]);

                // 满3个或者已经是最后一个元素时，输出一组
                if ((i + 1) % groupSize === 0 || i === items.length - 1) {
                  out += options.fn(group); // 将这一组数据传给模板
                  group = []; // 清空组，准备下一组
                }
              }

              return out;
            });
            var template = Handlebars.compile(source);
            var context = res.data;
            context.title = _this.tem_data.title;
            context.more_url = _this.tem_data.more_url;
            context.id = _this.type;
            var html = template(context);
            var wrap = document.getElementById(_this.cindex);
            wrap.innerHTML = html;
            var moreEl = wrap.querySelector(".group-title-all");
            if (moreEl) {
              moreEl.textContent = moreEl.textContent.replace(/\s*>\s*$/, "");
            }
            setTimeout(function() {
              _this.isshow = true;
            }, 1000);
            window.mySwiper = new Swiper(".recommendContainer", {
              loop: true, // 循环播放
              slidesPerView: "auto",
              observer: true,
              observeParents: true,
              spaceBetween: 18,
              autoplay: {
                delay: 3000, // 自动播放间隔
                disableOnInteraction: false // 点击后仍自动播放
              }
            });
            // $("#aa").html(html);
            // if(res.data.list[1].score){
            //   for(var i in res.data.list){
            //     if(res.data.list[i].score == 0){
            //       $('#new'+i).text('暂无评分').css({'line-height':43+'px','color':'#9EA7B4'});
            //     }else{
            //       var ins1 = rate.render({
            //         elem: $('#new'+i), //绑定元素
            //         length: 5,
            //         value: res.data.list[i].score/2,
            //         half: true,
            //         readonly: true,
            //         theme: '#EC6D3A',
            //         text: true,
            //         setText: function(value) {
            //           var arrs = {
            //             // '2': '极差',
            //             // '4': '差',
            //             // '6': '中等',
            //             // '8': '好',
            //             // '10': '非常好'
            //           };
            //           this.span.text(value*2 + "分");
            //         }
            //       });
            //     }
            //   }
            // }
          });
        } else {
          console.log("shibai");
        }
      });
      // $.ajax({
      //   url:'/api/proxy/index',
      //   type:'post',
      //   data:this.params,
      //   dataType:'json',
      //   success:function (res) {
      //     _this.listdata = res.data.list;
      //     _this.$nextTick(function () {
      //       console.log(res.data.list[1]);
      //       var source = $("#aa").html();
      //       var template = Handlebars.compile(source);
      //       var context = res.data.list[1];
      //       var html = template(context);
      //       document.getElementById('aa').innerHTML = html;
      //       // $("#aa").html(html);
      //       // if(res.data.list[1].score){
      //       //   for(var i in res.data.list){
      //       //     if(res.data.list[i].score == 0){
      //       //       $('#new'+i).text('暂无评分').css({'line-height':43+'px','color':'#9EA7B4'});
      //       //     }else{
      //       //       var ins1 = rate.render({
      //       //         elem: $('#new'+i), //绑定元素
      //       //         length: 5,
      //       //         value: res.data.list[i].score/2,
      //       //         half: true,
      //       //         readonly: true,
      //       //         theme: '#EC6D3A',
      //       //         text: true,
      //       //         setText: function(value) {
      //       //           var arrs = {
      //       //             // '2': '极差',
      //       //             // '4': '差',
      //       //             // '6': '中等',
      //       //             // '8': '好',
      //       //             // '10': '非常好'
      //       //           };
      //       //           this.span.text(value*2 + "分");
      //       //         }
      //       //       });
      //       //     }
      //       //   }
      //       // }
      //     });
      //   }
      // })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style id="g_style" scoped></style>
<!--横着排版-->
<!--<div class="group">-->
<!--<div class="group-title f-cb">-->
<!--<div class="group-title-text">{{title}}</div>-->
<!--<div class="group-title-all" onclick="routerlink('/lesson-list/{{more}}/{{id}}')">更多课程></div>-->
<!--</div>-->
<!--<div class="lesson2">-->
<!--<ul class="lesson2-items">-->
<!--{{#each list}}-->
<!--<li class="lesson2-item" onclick="routerlink('/lesson-detail/{{id}}')">-->
<!--<div class="lesson2-main">-->
<!--<div class="lesson2-pic f-img-box">-->
<!--<img src="{{cover_img}}">-->
<!--</div>-->
<!--<div class="lesson2-content">-->
<!--<div class="lesson2-name o1">{{teacher}}</div>-->
<!--<div class="lesson2-num o1">{{stu_num}}人</div>-->
<!--</div>-->
<!--{{#if play_num}}-->
<!--<div class="lesson2-score">{{score}}分</div>-->
<!--{{else}}-->
<!--<div class="lesson2-score">{{is_score score}}分</div>-->
<!--{{/if}}-->
<!--</div>-->
<!--<div class="lesson2-text o1">{{title}}</div>-->
<!--</li>-->
<!--{{/each}}-->
<!--</ul>-->
<!--</div>-->
<!--</div>-->
<!--竖着排版-->
<!--<div class="group">-->
<!--<div class="group-title f-cb">-->
<!--<div class="group-title-text">{{title}}</div>-->
<!--<div class="group-title-all" onclick="routerlink('/lesson-list/{{more}}/{{id}}')">更多课程 ></div>-->
<!--</div>-->
<!--<div class="collection">-->
<!--<ul class="collection-items">-->
<!--{{#each list}}-->
<!--<li class="collection-item f-cb" onclick="routerlink('/topic/{{id}}')">-->
<!--<div class="collection-left">-->
<!--<div class="collection-pic f-img-box">-->
<!--<img src="{{cover_img}}">-->
<!--</div>-->
<!--<div class="collection-left-text">合集</div>-->
<!--</div>-->
<!--<div class="collection-content">-->
<!--<div class="collection-title o1">{{title}}</div>-->
<!--<div class="collection-text o1">{{center_name}}</div>-->
<!--<div class="collection-info f-cb">-->
<!--<div class="collection-num">{{course_num}}门课</div>-->
<!--<div class="collection-hot">{{stu_num}}人在学</div>-->
<!--</div>-->
<!--</div>-->
<!--</li>-->
<!--{{/each}}-->
<!--</ul>-->
<!--</div>-->
<!--</div>-->



// WEBPACK FOOTER //
// src/components/list-template/list-template.vue